import { SuppliersScreen } from './SuppliersScreen.jsx';

export default {
  path: '/suppliers',
  element: <SuppliersScreen />,
  protected: true,
  permission: null,
  // المفتاح المخصّص أولاً، ومعه مفاتيح المشتريات القائمة حتى تعمل الشاشة
  // للأدوار الحالية قبل إعادة الزرع وإعادة الدخول.
  anyPermission: ['suppliers.accounts.view', 'suppliers.settle', 'inventory.purchase.view', 'inventory.purchase.manage'],
  standalone: false,
  sidebar: { label: 'حسابات الموردين', icon: 'purchase', group: 'inventory', order: 73 }
};
